import { useEffect, useRef, useState } from 'react';

// WebSocket del chat (mismo protocolo que tenía el monolito: "saludo" al
// abrir y recarga de mensajes al recibir). Opcional: si no hay url, no hace
// nada y el chat funciona solo con el polling. Se cierra al desmontar.
export default function useChatSocket({ url, referencia, tipoUsuario, onMensaje, claveCodigoUsuario = 'codigoUsuario' }) {
  const [estado, setEstado] = useState(url ? 'reconectando' : 'sin-socket');
  const socketRef = useRef(null);
  const activo = useRef(true);
  const onMensajeRef = useRef(onMensaje);
  onMensajeRef.current = onMensaje;

  useEffect(() => {
    if (!url || typeof WebSocket === 'undefined') {
      return undefined;
    }
    activo.current = true;
    let reintento = null;

    const conectar = () => {
      if (!activo.current) {
        return;
      }
      setEstado('reconectando');
      let socket;
      try {
        socket = new WebSocket(url);
      } catch (e) {
        reintento = setTimeout(conectar, 5000);
        return;
      }
      socketRef.current = socket;

      socket.onopen = () => {
        socket.send(
          JSON.stringify({
            tipoMensaje: 'saludo',
            [referencia.campo]: referencia.valor,
            codigoUsuario: localStorage.getItem(claveCodigoUsuario),
            tipo: tipoUsuario,
          }),
        );
        setEstado('conectado');
      };
      socket.onmessage = () => {
        if (onMensajeRef.current) {
          onMensajeRef.current();
        }
      };
      socket.onclose = () => {
        if (activo.current) {
          setEstado('reconectando');
          reintento = setTimeout(conectar, 5000);
        }
      };
      socket.onerror = () => {};
    };

    conectar();
    return () => {
      activo.current = false;
      if (reintento) {
        clearTimeout(reintento);
      }
      if (socketRef.current) {
        socketRef.current.onclose = null;
        socketRef.current.close();
      }
    };
  }, [url, referencia.campo, referencia.valor, tipoUsuario]);

  return estado;
}
